import { FCX } from "@datassential/platform-ui-lib";
import { useConsumerGroupsContext } from "@pages/Profile/components/ConsumerGroups/ConsumerGroups";
import { useSupermarkets } from "@core/CommonDataContext";
import {
    ConsumerGroupsTableItem,
    useConsumerGroupsTableMetrics
} from "./ConsumerGroupsTableConfig";
import { useMemo } from "react";
import Common from "@pages/Profile/components/ConsumerGroups/Common";

const Supermarkets: FCX = (props) => {
    const getMetricsData = useConsumerGroupsTableMetrics();
    const { data } = useConsumerGroupsContext();

    const options = useSupermarkets();

    const supermarketsData = useMemo(
        (): ConsumerGroupsTableItem[] => {
            return (data.supermarkets ?? []).map((item) => {
                const itemData = options.find((i) => i.id === item.id);

                return {
                    id: item.id,
                    name: itemData?.name ?? '',
                    baseSize: item.base ?? 0,
                    metrics: getMetricsData(item.metrics ?? []),
                };
            });
        },
        [options, data.supermarkets, getMetricsData]
    );

    return (
        <Common {...props} data={supermarketsData} isVirtualized/>
    );
}

export default Supermarkets;